"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var BaseController_1 = require("../../../../../shared/controllers/BaseController");
var webAApi_1 = require("../../../../api/webAApi");
var UIUtils_1 = require("../../../../../shared/modules/UIUtils");
var moment = require("moment");
var PlayerTournamentsListCtl = /** @class */ (function (_super) {
    __extends(PlayerTournamentsListCtl, _super);
    function PlayerTournamentsListCtl(errDialog) {
        var _this = _super.call(this, true) || this;
        _this.dk_key = UIUtils_1.UIUtils.IProp2Str(function (o) { o.key; });
        _this.dk_title = UIUtils_1.UIUtils.IProp2Str(function (o) { o.title; });
        _this.dk_is_published = UIUtils_1.UIUtils.IProp2Str(function (o) { o.is_published; });
        _this.dk_brand_id = UIUtils_1.UIUtils.IProp2Str(function (o) { o.brand_id; });
        _this.dk_brand_title = UIUtils_1.UIUtils.IProp2Str(function (o) { o.brand_title; });
        _this.dk_is_req_player_level = UIUtils_1.UIUtils.IProp2Str(function (o) { o.is_req_player_level; });
        _this.dk_min_player_level_id = UIUtils_1.UIUtils.IProp2Str(function (o) { o.min_player_level_id; });
        _this.dk_min_player_level_title = UIUtils_1.UIUtils.IProp2Str(function (o) { o.min_player_level_title; });
        _this.dk_is_req_deposit_during_age = UIUtils_1.UIUtils.IProp2Str(function (o) { o.is_req_deposit_during_age; });
        _this.dk_deposit_age_type_code = UIUtils_1.UIUtils.IProp2Str(function (o) { o.deposit_age_type_code; });
        _this.dk_deposit_age_type_title = UIUtils_1.UIUtils.IProp2Str(function (o) { o.deposit_age_type_title; });
        _this.dk_is_req_deposit_amount_during_age = UIUtils_1.UIUtils.IProp2Str(function (o) { o.is_req_deposit_amount_during_age; });
        _this.dk_cms_gameset_id = UIUtils_1.UIUtils.IProp2Str(function (o) { o.cms_gameset_id; });
        _this.dk_cms_gameset_title = UIUtils_1.UIUtils.IProp2Str(function (o) { o.cms_gameset_title; });
        _this.dk_tournament_state_code = UIUtils_1.UIUtils.IProp2Str(function (o) { o.tournament_state_code; });
        _this.dk_tournament_state_title = UIUtils_1.UIUtils.IProp2Str(function (o) { o.tournament_state_title; });
        _this.dk_description = UIUtils_1.UIUtils.IProp2Str(function (o) { o.description; });
        _this.dk_number_of_prizes = UIUtils_1.UIUtils.IProp2Str(function (o) { o.number_of_prizes; });
        _this.dk_player_place = UIUtils_1.UIUtils.IProp2Str(function (o) { o.player_place; });
        _this.dk_date_added = UIUtils_1.UIUtils.IProp2Str(function (o) { o.date_added; });
        _this.dk_date_changed = UIUtils_1.UIUtils.IProp2Str(function (o) { o.date_changed; });
        _this.dk_date_start = UIUtils_1.UIUtils.IProp2Str(function (o) { o.date_start; });
        _this.dk_date_end = UIUtils_1.UIUtils.IProp2Str(function (o) { o.date_end; });
        _this.dk_start_day = UIUtils_1.UIUtils.IProp2Str(function (o) { o.start_day; });
        _this.dk_start_month = UIUtils_1.UIUtils.IProp2Str(function (o) { o.start_month; });
        _this.dk_start_year = UIUtils_1.UIUtils.IProp2Str(function (o) { o.start_year; });
        _this.dk_end_day = UIUtils_1.UIUtils.IProp2Str(function (o) { o.end_day; });
        _this.dk_end_month = UIUtils_1.UIUtils.IProp2Str(function (o) { o.end_month; });
        _this.dk_end_year = UIUtils_1.UIUtils.IProp2Str(function (o) { o.end_year; });
        _this.dk_max_buys_count = UIUtils_1.UIUtils.IProp2Str(function (o) { o.max_buys_count; });
        _this.dk_player_buys_count = UIUtils_1.UIUtils.IProp2Str(function (o) { o.player_buys_count; });
        _this.dk_freespin_count = UIUtils_1.UIUtils.IProp2Str(function (o) { o.freespin_count; });
        _this.dk_is_unlimited_buys_count = UIUtils_1.UIUtils.IProp2Str(function (o) { o.is_unlimited_buys_count; });
        _this._errDialog = errDialog;
        return _this;
    }
    PlayerTournamentsListCtl.prototype.ResetData = function () {
        this.DATA = {
            data: [],
            total: 0
        };
    };
    PlayerTournamentsListCtl.prototype.getById = function (id) {
        for (var i = 0; i < this.DATA.data.length; i++) {
            if (this.DATA.data[i].key === id) {
                return this.DATA.data[i];
            }
        }
        throw "bonus tournament range with id [" + id + "] not found !";
    };
    PlayerTournamentsListCtl.prototype.LoadData = function (data, onDone) {
        var _this = this;
        webAApi_1.ListBonusTournamentsByUsrPlayerIdGet.exec({
            usr_player_id: data.playerId,
            from_year: data.from_year,
            from_month: data.from_month,
            from_day: data.from_day,
            from_hour: data.from_hour,
            from_minute: data.from_minute,
            to_year: data.to_year,
            to_month: data.to_month,
            to_day: data.to_day,
            to_hour: data.to_hour,
            to_minute: data.to_minute
        }, function (resp) {
            _this.DATA.data = [];
            _this.DATA.total = resp.total_count;
            //
            for (var i = 0; i < resp.list.length; i++) {
                _this.DATA.data.push({
                    key: resp.list[i].key_uid,
                    title: resp.list[i].title,
                    is_published: resp.list[i].is_published,
                    brand_id: resp.list[i].brand_id,
                    brand_title: resp.list[i].brand_title,
                    is_req_player_level: resp.list[i].is_req_player_level,
                    min_player_level_id: resp.list[i].min_player_level_id,
                    min_player_level_title: resp.list[i].min_player_level_title,
                    is_req_deposit_during_age: resp.list[i].is_req_deposit_during_age,
                    deposit_age_type_code: resp.list[i].deposit_age_type_code,
                    deposit_age_type_title: resp.list[i].deposit_age_type_title,
                    is_req_deposit_amount_during_age: resp.list[i].is_req_deposit_amount_during_age,
                    cms_gameset_id: resp.list[i].cms_gameset_id,
                    cms_gameset_title: resp.list[i].cms_gameset_title,
                    tournament_state_code: resp.list[i].tournament_state_code,
                    tournament_state_title: resp.list[i].tournament_state_title,
                    number_of_prizes: resp.list[i].number_of_prizes,
                    player_place: resp.list[i].player_place,
                    description: resp.list[i].description,
                    date_added: moment(resp.list[i].date_added_uts_ms).utc(false),
                    date_changed: moment(resp.list[i].date_changed_uts_ms).utc(false),
                    date_start: moment(resp.list[i].date_start_uts_ms).utc(false),
                    date_end: moment(resp.list[i].date_end_uts_ms).utc(false),
                    start_day: resp.list[i].start_day,
                    start_month: resp.list[i].start_month,
                    start_year: resp.list[i].start_year,
                    end_day: resp.list[i].end_day,
                    end_month: resp.list[i].end_month,
                    end_year: resp.list[i].end_year,
                    max_buys_count: resp.list[i].max_buys_count,
                    player_buys_count: resp.list[i].player_buys_count,
                    freespin_count: resp.list[i].freespin_count,
                    is_unlimited_buys_count: resp.list[i].is_unlimited_buys_count
                });
            }
            _this.Update();
            if (onDone) {
                onDone();
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    return PlayerTournamentsListCtl;
}(BaseController_1.BaseController));
exports.PlayerTournamentsListCtl = PlayerTournamentsListCtl;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/main_players_list/ctl/PlayerTournamentsLictCtl.ts
// module id = 1025
// module chunks = 0